export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["扣除总额"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["佣金"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["信息"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["入账"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["无法计算金额"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["余额不足，无法付款"])}
}